export function getUrl () {
  return 'https://ky.docteams.cn/apidoctor/'
}